import { defineStore } from 'pinia';

export const useIndexStore = defineStore('indexStore', {
  state: () => ({
    globalLoading: false,
    newNotification: {},
    successNotification: {},
    websocketMessages: ''
  }),
  actions: {
    updateLoading(value) {
      this.globalLoading = value;
    },
    updateNotification(notification) {
      this.newNotification = notification;
    },
    updateSuccessNotification(notification) {
      this.successNotification = notification;
    },
    updateWebsocketMessages(message) {
      this.websocketMessages = message;
    }
  }
});
